import { useState } from 'react';
import cn from 'classnames';
import { creatorbase } from '@round/api';
import { Button, Textarea } from '@round/creatorbase-ui';
import { parseUrlsFromText } from '../../helpers';
import styles from './PasteUrls.module.css';

type Props = {
    onAdd: (urls: string[]) => void;
};

const PasteUrls = ({ onAdd }: Props) => {
    const [text, setText] = useState('');
    const urls = parseUrlsFromText(text);
    const isOverLimit = urls.length > creatorbase.MAX_CLASSIFY_LINES;

    return (
        <div className={styles.container}>
            <Textarea
                value={text}
                onChange={(e) => setText(e.target.value)}
                placeholder="Paste one profile URL per line"
                className={styles.textarea}
            />

            <span className={cn(styles.counter, { [styles.counterOverLimit]: isOverLimit })}>
                {urls.length} / {creatorbase.MAX_CLASSIFY_LINES}
            </span>

            <div className={styles.footer}>
                <Button
                    size="sm"
                    variant="default"
                    disabled={urls.length === 0 || isOverLimit}
                    onClick={() => onAdd(urls)}
                >
                    Continue
                </Button>
            </div>
        </div>
    );
};

export default PasteUrls;
